import { Box } from "@mui/material";
import Markdown from "react-markdown";
import rehypeKatex from "rehype-katex";
import remarkMath from "remark-math";

import "katex/dist/katex.min.css";

const RenderPaperTitleMarkdown = ({ paperTitle }) => (
  <Box
    component="span"
    sx={{
      lineHeight: 0,
      "& .katex": {
        font: "unset !important"
      }
    }}
  >
    <Markdown
      remarkPlugins={[remarkMath]}
      rehypePlugins={[rehypeKatex]}
      components={{ p: "span" }}
    >
      {paperTitle}
    </Markdown>
  </Box>
);

export default RenderPaperTitleMarkdown;
